import { SquareCheck } from "lucide-react";
import React, { useState } from "react";
import { FaTimes } from "react-icons/fa";
import { MdOutlineOpenInNew } from "react-icons/md";
import SimuladorEconomia from "../simulador-economia/SimuladorEconomia.jsx";
import { Button } from "../ui/button.jsx";
import Modal from "../ui/modal-default.jsx";

const FirstBlockVC = ({ setShowModal }) => {
  const [modalState, setModalState] = useState(null);

  // const scrollToBottom = () => {
  //   window.scrollTo({
  //     top: 400,
  //     behavior: "smooth",
  //   });
  // };

  return (
    <div className="lg:bg-[url('assets/images/banners/bg-hero.webp')] bg-secondary-color bg-cover bg-no-repeat">
      <div className="w-screen py-14 lg:py-28 justify-center items-center gap-[62px] inline-flex">
        <div className="w-full max-w-[85rem] px-6 md:px-10 flex flex-col lg:flex-row justify-between items-end gap-5">
          {/* texto título */}
          <div className="lg:w-1/2 w-full flex-col justify-start items-start gap-[52px] inline-flex max-lg:pb-8">
            <div className="flex-col justify-start items-start gap-6 flex w-full">
              <div className="w-full flex-col justify-center items-start gap-6 flex">
                <h1 className="text-gray-200 w-full text-left text-4xl lg:text-5xl font-thin lg:leading-[60px] leading-[52px] ">
                  <strong className="font-bold ">
                    Economize <br className=" lg:flex" />
                    até 15% ao mês
                  </strong>{" "}
                  <br className="flex" />
                  na conta de energia.
                </h1>
                <div className="flex flex-col gap-3 ">
                  <div className="flex items-center gap-2 ">
                    <SquareCheck
                      strokeWidth={1.3}
                      className="w-8 h-8 text-gray-200"
                    />
                    <span className="text-gray-200 text-xl font-thin">
                      Sem custo
                    </span>
                  </div>
                  <div className="flex items-center gap-2 ">
                    <SquareCheck
                      strokeWidth={1.3}
                      className="w-8 h-8 text-gray-200"
                    />
                    <span className="text-gray-200 text-xl font-thin">
                      Sem obras
                    </span>
                  </div>
                  <div className="flex items-center gap-2 ">
                    <SquareCheck
                      strokeWidth={1.3}
                      className="w-8 h-8 text-gray-200"
                    />
                    <span className="text-gray-200 text-xl font-thin">
                      Sem taxa de adesão
                    </span>
                  </div>
                  <div className="flex items-center gap-2 ">
                    <SquareCheck
                      strokeWidth={1.3}
                      className="w-8 h-8 text-gray-200"
                    />
                    <span className="text-gray-200 text-xl font-thin">
                      Sem fidelidade
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <SimuladorEconomia />

          <Modal
            isOpen={modalState !== null}
            onClose={() => setModalState(null)}
          >
            {modalState === "success" && (
              <div className="flex flex-col h-[100vh] items-start justify-end md:justify-center">
                <div className="relative flex flex-col items-center justify-center w-[100vw] md:w-[360px] md:h-[310px] bg-white border rounded-t-3xl md:rounded-xl py-10 px-6">
                  <button
                    className="absolute top-4 right-4 text-black"
                    onClick={() => setModalState(null)}
                    aria-label="Fechar modal"
                  >
                    <FaTimes className="w-5 h-5" />
                  </button>
                  <MdOutlineOpenInNew size={40} color="red" />
                  <p className="text-xl text-center font-medium px-4 mt-4 mb-10">
                    Você será direcionado para o portal do nosso parceiro
                    Thopen.
                  </p>
                  <Button
                    variant="secondary"
                    size="lg"
                    className="w-full"
                    onClick={() => console.log("redireciona!")}
                  >
                    Entendi
                  </Button>
                </div>
              </div>
            )}
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default FirstBlockVC;
